const FOCUSABLE = "button, [href], input, select, textarea, [tabindex], summary";
export function getAllFocusables(container = document.body) {
  if (!(container instanceof HTMLElement)) {
    container = document.querySelector(container);
  }
  if (!container) {
    console.warn("You need to pass a parent HTMLElement");
    return [];
  }
  return Array.from(container.querySelectorAll(FOCUSABLE)).filter(
    (el) => !el.hasAttribute("disabled") && !el.getAttribute("aria-hidden") && el.style.display !== "none" && (!el.getAttribute("tabindex") || el.tabIndex >= 0)
  );
}
export function getFirstFocusable(container = document.body) {
  const results = getAllFocusables(container);
  return results.length ? results[0] : null;
}
